import React, { useEffect, useRef, useState, useCallback } from 'react';
import classNames                                          from 'classnames';

import DealerRequest             from '../DealerRequest/components/DealerRequest';
import { useDealerRequestModal } from '../../providers/dealerRequest';

const DealerRequestModal = () => {
  const {
          hideModal,
          open,
        } = useDealerRequestModal();

  const [show, setShow] = useState(false);
  const modalRef        = useRef(null);

  const closeModal = useCallback(() => {
    if (show) {
      setShow(false);
    }
    hideModal();
  }, [show, hideModal]);

  const keyDown = useCallback(({ keyCode }) => {
    if (open && show && keyCode === 27) {
      closeModal();
    }
  }, [open, show, closeModal]);

  const handleClickOutside = useCallback((event) => {
    if (open && modalRef.current && !modalRef.current.contains(event.target)) {
      closeModal();
    }
  }, [open, closeModal]);

  useEffect(() => {
    if (show) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('touchstart', handleClickOutside);
      document.addEventListener('keydown', keyDown);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
      document.removeEventListener('keydown', keyDown);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
      document.removeEventListener('keydown', keyDown);
    };
  }, [show, handleClickOutside, keyDown]);

  useEffect(() => {
    if (open) {
      if (!show) {
        setTimeout(() => {
          setShow(true);
        }, 100);
      }
    }
  }, [open]);

  useEffect(() => {
    document.body.classList.toggle('fixed', open && show);
  }, [open, show]);

  if (!show) {
    return null;
  }

  return (
    <div
      className={classNames('modal-overlay', 'dealer_request_modal_overlay', {
        show,
      })}
    >
      <DealerRequest closeModal={closeModal} modalRef={modalRef} />
    </div>
  );
};

export default DealerRequestModal;